import Catalyst from '@Services/Catalyst';

// eslint-disable-next-line import/prefer-default-export
export const trackHeatmapButtonClick = () => {
  // e204
  Catalyst.trackEvent('buttonClick', {
    buttonType: 'bioactivity visualization', // v124 Button Type
  });
};
